module.exports = __webpack_public_path__ + "images/cultureel_centrum-dc7b817e05e94a81ea69eed2a324bd85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos_icons/cultureel_centrum.svg
// module id = 768
// module chunks = 0